// Campaign feature flags for the SCHOOL login experience.
//
// EKPED3_SCHOOL_ENABLED — Ek Ped Maa Ke Naam 3.0 for schools. When false:
//   • no post-login "Have you participated?" popup (OutletRouteSchool)
//   • no "Ek Ped Maa Ke Naam 3.0" program card / Add-Update Details button
//     and no 3.0 certificate link on the school dashboard (SchoolProgramCards)
//   • the "Number of Saplings Planted" stat falls back to the legacy
//     get-matrix-data figure instead of the 3.0 running total (Dashboard)
//   • /school/certificate-3 redirects to the dashboard (SchoolRoutingPage)
//   • the ekpedmaakenaam3-count query is never fired for schools
// Admin reports / public plantation stats are NOT affected by this flag.
// Disabled on 2026-10-12.
export const EKPED3_SCHOOL_ENABLED = false;

// SWACHHATA_QUIZ_OPEN — Swachhata Hi Seva 2026 public student quiz. When false:
//   • /swachhata-hi-seva keeps the learning material, results and certificates
//     already earned, but offers no new quiz (SwachhataPublic)
//   • no "Take the quiz" links on the landing page (AnnouncementStrip,
//     SwachhataHome) and no quiz invitation on the school's students page
// The server refuses new attempts too (Backend2 Routes/APIRouter.js).
// Closed on 2026-10-20.
export const SWACHHATA_QUIZ_OPEN = false;

// SWACHHATA_SWM_REPORT_OPEN — the school's Solid Waste Management report
// (Swachhata Hi Seva 2026). When false: no post-login SWM popup and no
// Fill Form / Update Details button (OutletRouteSchool, SchoolProgramCards);
// the E-Waste popup no longer waits for it. Schools that submitted keep their
// certificate. The server refuses new reports too. Closed on 2026-10-20.
export const SWACHHATA_SWM_REPORT_OPEN = false;

// EWASTE_DRIVE_OPEN — the school's E-Waste Collection Drive report. When false:
//   • no post-login E-Waste popup and no Fill Form / Update Details button
//     (OutletRouteSchool, SchoolProgramCards); schools that already reported
//     keep their card and their figures, read-only
// The server refuses new reports too (403 EWASTE_CLOSED in Routes/APIRouter.js).
// The public E-Waste events page and every admin report stay open.
// Closed on 2026-10-31.
export const EWASTE_DRIVE_OPEN = false;

// EWASTE_CARD_VISIBLE — whether the E-Waste card appears on the school
// dashboard at all. The drive closed on 31 Oct and the card was left behind
// read-only so reporting schools kept their figures; it was taken off the
// signed-in dashboard on 3 Nov because the drive is over and the week's
// reporting is what schools need to see. The admin reports are untouched and
// no school data is deleted — set this back to true to bring the card back.
export const EWASTE_CARD_VISIBLE = false;
